import React from 'react';
import { Sec, SecTitle, Box, Notes } from '../styled';

// 数据源与口径：按 demo-开发用.html 文案
const CaliberNote = ({ data }) => (
  <Sec>
    <SecTitle>数据源与口径</SecTitle>
    <Box>
      <Notes>
        · 已售 = 台上见自有订单 + 文广票池 T+1 同步
        <br />· 台上见销量、余票、台上见订单：近实时，数据截止时间{' '}
        {data?.dataAsOf}
        <br />· 销售金额不包含人工退票；VIP 以下单时点是否为 888 判定
        <br />· 小程序埋点、地域为 IP 清洗：T+1
      </Notes>
    </Box>
  </Sec>
);

export default CaliberNote;
